export interface INotification {
	id: number
	created_dt: number
	status: string
	type: NotificationType
	title: string
	text: string
	shift: Shift
	groups: INotificationGroups[]
	all_groups: boolean
	content_type: number
	object_id: number
	payload: PayloadNotifications
}

export interface PayloadNotifications {
	items: PayloadNotificationItem[]
}

export interface PayloadNotificationItem {
	label: string
	value: string
	old_value: string | null
	old_value_color: '#EB4D3D' | '#65C466' | null
}

export interface INotificationGroups {
	id: number
	title: string
}

export type Shift = 'am' | 'pm' | 'night'

export enum NotificationType {
	FEED_PLAN_DEVIATION = 'feedplan_deviation',
	FEED_PLAN_REMINDER = 'feedplan_reminder',
	NUDGE_NEEDED = 'nudge_needed',
	CAMERA_ISSUE = 'camera_issue',
	CAMERA_ISSUE_RESOLVED = 'camera_issue_resolved',
	RATION_GROUP_LINK = 'ration_group_link',
	HEALTH_TODAY_PLAN = 'health_today_plan',
	HEALTH_STATISTICS = 'health_statistics',
	HEALTH_FATNESS_STATISTICS = 'health_fatness_statistics',
	MILKING_PROCESS_DEVIATIONS = 'milking_process_deviations',
	RATION_CHANGE = 'ration_change',
}

export interface INotificationsResponse {
	next: string | null
	previous: string | null
	results: INotification[]
}

export enum NotificationsTypes {
	DailyChangedWeight = 'dailyChangedWeight',
}
